import React from 'react';
import { EDITOR_TOOLS } from './constants';
import { useEditor } from './EditorContext';
import BasicsPanel from './panels/BasicsPanel';
import TextPanel from './panels/TextPanel';
import ShapesPanel from './panels/ShapesPanel';
import ButtonsPanel from './panels/ButtonsPanel';
import StickersPanel from './panels/StickersPanel';
import GoogleMapPanel from './panels/GoogleMapPanel';
import CanvasToolbar from './CanvasToolbar';
import LayersPanel from './LayersPanel';
import ZoomBar from './ZoomBar';

const PANELS = {
  basics: BasicsPanel,
  text: TextPanel,
  shapes: ShapesPanel,
  buttons: ButtonsPanel,
  stickers: StickersPanel,
  googleMap: GoogleMapPanel,
};

export default function EditorShell({ canvasRef, ready }) {
  const { activeTool, setActiveTool, layersOpen } = useEditor();
  const Panel = PANELS[activeTool] || BasicsPanel;

  return (
    <div className="pixie-editor">
      <nav className="pixie-nav" aria-label="Editor tools">
        {EDITOR_TOOLS.map((tool) => (
          <button
            key={tool.id}
            type="button"
            className={`pixie-nav-btn ${activeTool === tool.id ? 'active' : ''}`}
            onClick={() => setActiveTool(tool.id)}
            title={tool.label}
          >
            <i className={`fa-solid ${tool.icon}`} aria-hidden />
            <span>{tool.label}</span>
          </button>
        ))}
      </nav>

      <aside className="pixie-tool-panel">
        <Panel />
      </aside>

      <div className="pixie-canvas-area">
        <CanvasToolbar />
        <div className="pixie-viewport-wrap">
          {!ready && <div className="at-editor-loading">Loading canvas…</div>}
          {layersOpen && <LayersPanel />}
          <div className="pixie-viewport at-editor-viewport">
            <canvas ref={canvasRef} id="alert-template-canvas" />
          </div>
        </div>
        <ZoomBar />
      </div>
    </div>
  );
}
